/**
 * @generated SignedSource<<49e7a03ff2be9b796b6acb6a34556725>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteNoteModalDeleteRecordingMutation$variables = {
  recordingId: string;
};
export type DeleteNoteModalDeleteRecordingMutation$data = {
  readonly deleteRecording: {
    readonly note: {
      readonly hasMeetingRecordings: boolean;
      readonly id: string;
      readonly meetingRecordings: ReadonlyArray<{
        readonly id: string;
      }> | null;
    } | null;
  } | null;
};
export type DeleteNoteModalDeleteRecordingMutation = {
  response: DeleteNoteModalDeleteRecordingMutation$data;
  variables: DeleteNoteModalDeleteRecordingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recordingId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "recordingId",
        "variableName": "recordingId"
      }
    ],
    "concreteType": "DeleteRecording",
    "kind": "LinkedField",
    "name": "deleteRecording",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasMeetingRecordings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecordings",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNoteModalDeleteRecordingMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteNoteModalDeleteRecordingMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "daf988fbbaf71ead991253b180624a73",
    "id": null,
    "metadata": {},
    "name": "DeleteNoteModalDeleteRecordingMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNoteModalDeleteRecordingMutation(\n  $recordingId: ID!\n) {\n  deleteRecording(recordingId: $recordingId) {\n    note {\n      id\n      hasMeetingRecordings\n      meetingRecordings {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8165b71f7064ee671407b998711a1908";

export default node;
